import { get } from '../../utils/lodash';

export function constructData(props) {
  const { accountDetail = {} } = props;
  const { first_name = '', last_name = '', email = '', phone = '', company_id = '', company_name = '', profile_id= '' } = accountDetail;
  const data = {
    first_name,
    last_name,
    email,
    phone,
    company_id,
    company_name,
    profile_id
  };
  return data;
}

export function getAccountDetails(accountData) {
  const { first_name = '', last_name = '', email = '', phone = '', company_id = '', company_name = '', profile_id = '' } = accountData;
  return {
    firstName: first_name,
    lastName: last_name,
    email,
    phone,
    companyId: company_id,
    companyName: company_name,
    profile_id
  };
}

export function isUserHomeowner(accountDetails) {
  const isSelfInstaller = get(accountDetails, 'self_installer', false);
  return accountDetails.company_id === null && !isSelfInstaller;
}
